import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import Label from '@/models/Label';
import { UserRepository } from '@/repositories/UserRepository';
import { capitalizeWord } from '@/helpers/TranslationHelper';
import { ProjectTypes } from '@/enums/models/ProjectTypes';
import OrderStatus from '@/models/OrderStatus';
import {
    generateSearchFilterAndNavigateHome,
    getNumberOfProjectsBasedOnSearchFilters,
} from '@/helpers/IntroScreenHelper';
import { RouteNames } from '@/enums/routes/RouteNames';

interface Props {
    title: string;
    label: Label | null;
    state: string;
    orderStatus: OrderStatus | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsOverviewField',
  props: {
    title: null,
    label: null,
    state: null,
    orderStatus: null
  },
  emits: ["openProjectTableWithFilters"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'openProjectTableWithFilters'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title: string;
    label: Label | null;
    state: string;
    orderStatus: OrderStatus | null;
};





const numberOfProjects = ref<null | number>(null);

const currentUser = computed(() => {
    return UserRepository.getCurrentUser();
});

function convertProjectStateNameToEnum(projectStateName: string) {
    const capitalizedProjectStateName = capitalizeWord(projectStateName) as keyof typeof ProjectTypes;
    return ProjectTypes[capitalizedProjectStateName] as keyof typeof ProjectTypes;
}

function openProjectTableWithFilters() {
    emit('openProjectTableWithFilters');

    generateSearchFilterAndNavigateHome({
        currentUser: currentUser.value,
        type: convertProjectStateNameToEnum(props.state === 'request' ? 'offer' : props.state),
        label: props.label,
        orderStatus: props.orderStatus,
        query: '',
        shouldSetActiveTab: true,
        stateSwitchForOffers: props.state === 'request',
        route: RouteNames.home,
    });
}

onMounted(async () => {
    const isUserSalesman = currentUser.value ? currentUser.value.isSalesman : false;

    numberOfProjects.value = await getNumberOfProjectsBasedOnSearchFilters({
        type: props.state,
        label: props.label,
        orderStatus: props.orderStatus,
        currentUser: isUserSalesman ? currentUser.value : null,
    });
});

return { __sfc: true,props, emit, numberOfProjects, currentUser, convertProjectStateNameToEnum, openProjectTableWithFilters }
}

})